import React from 'react';
import './style.css';

export default ({href, title, description, image, children, target = null}) => (
    <a className="ImageButton" href={href} target={target}>
        <div><img className="ImageButton-image" src={image} alt={title} /></div>
        <div>
            <div className="ImageButton-title">{title}</div>
            <div className="ImageButton-children">{children}</div>
        </div>
    </a>
);



// WEBPACK FOOTER //
// ./src/common/input/ImageButton/index.js